<mat-dialog-content style="max-height: 77vh; height: 77vh;">
    <div class="popup-head">Add Master Restaurant</div>
    <div>
        <div style="display: grid;grid-template-columns: 1fr 1fr;gap: 10px 30px;;padding: 0 17px;">
            <div>
                <div class="popup-subhead" style="margin-top: 15px;">Master Restaurant Name</div>
                <input type="text"  [(ngModel)]="restoName"
                    class="form-control popup-input" />
            </div>
            <div>
                <div class="popup-subhead" style="margin-top: 15px;">Email</div>
                <input type="email"  [(ngModel)]="restoEmail" [disabled]="data.isEdit"
                    class="form-control popup-input" />
            </div>
            <div>
                <div class="popup-subhead">Mobile</div>
                <input type="text"  [(ngModel)]="restoPhone"
                    class="form-control popup-input" />
            </div>
            <div>
                <div class="popup-subhead">Password</div>
                <input type="text"  [(ngModel)]="password"
                    class="form-control popup-input" />
            </div>

        </div>


        <div class="restaurant-dialog">
            <div class="restaurant-container">
                <!-- All Restaurants (Left Side) -->
                <div class="restaurant-box">
                    <div class="popup-subhead" style="margin-top: 0;margin-bottom: 5px;">All Restaurant </div>
                    <div class="search-header">
                        <input type="text" placeholder="Search restaurants" [(ngModel)]="leftSearch"
                            (input)="filterLeftList()" />
                    </div>
                    <div class="restaurant-list">
                        <div *ngFor="let restaurant of filteredLeftList" [class.selected]="isSelected(restaurant)"
                            class="restaurant-item">
                            <span>{{ restaurant.restaurant_name }}</span>
                            <button class="add-btn" (click)="addToSelected(restaurant)">Add</button>
                        </div>
                    </div>
                </div>

                <!-- Selected Restaurants (Right Side) -->
                <div class="restaurant-box">
                    <div class="popup-subhead" style="margin-top: 0;margin-bottom: 5px;" >Selected Restaurant</div>
                    <div class="search-header">
                        <input type="text" placeholder="Search selected" [(ngModel)]="rightSearch"
                            (input)="filterRightList()" />
                    </div>
                    <div class="restaurant-list">
                        <div *ngFor="let restaurant of filteredRightList" class="restaurant-item selected">
                            <span>{{ restaurant.restaurant_name }}</span>
                            <button class="delete-btn" (click)="removeFromSelected(restaurant)">Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <div>

        </div>
    </div>
    <div class="buttomPartAddResto">
        <div (click)="close(false)" class="common closeBtn">
            Close
        </div>
        <div (click)="dataFunc()" class="common submitBtn">
            Submit
        </div>
    </div>
</mat-dialog-content>
<style>
    ::ng-deep .mat-dialog-container {
        padding: 0;

        overflow-x: hidden;
    }

    ::ng-deep .mat-dialog-content::-webkit-scrollbar {
        display: none;
    }

    .popup-head {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        color: rgba(57, 64, 70, 1);
        background-color: rgba(238, 238, 238, 1);
        width: 873px;
        height: 52px;
        display: flex;
        align-items: center;
        padding-left: 25px;
    }

    .popup-subhead {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        color: rgba(23, 83, 117, 1);
        margin-top: 5px;
    }

    .popup-input {
        width: 100%;
        margin: 5px 0px;
    }

    .popup-addBtnIcon {
        width: 30px;
        height: 30px;
        margin-top: 64px;
        margin-left: 40px;
        cursor: pointer;
    }

    .buttomPartAddResto {
        display: flex;
        justify-content: end;
    }

    .common {
        padding: 5px 29px;
        margin: 30px 9px;
        cursor: pointer;
        font-family: "Roboto";
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        border-radius: 6px;
    }

    .common:hover {
        box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
            rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    }

    .closeBtn {
        color: rgba(57, 64, 70, 1);
        border: 2px solid rgba(57, 64, 70, 1);
    }

    .submitBtn {
        color: rgba(255, 255, 255, 1);
        background: linear-gradient(90.17deg, #2fb9e3 -97.61%, #56ab51 120.65%);
        border-radius: 6px;
    }

    /* upload btn */
    .uploadBtn {
        width: 121px;
        height: 41px;
        border-radius: 6px;
        background-color: rgba(84, 172, 88, 1);
        border: none;
    }

    .uploadBtn span {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: rgba(242, 242, 242, 1);
        padding-left: 10px;
    }

    .imgPreview {
        width: 51px;
        height: 51px;
        border-radius: 25px;
    }




    .restaurant-dialog {
        display: flex;
        flex-direction: column;
        padding: 1rem;
    }

    .restaurant-container {
        display: flex;
        gap: 2rem;
    }

    .restaurant-box {
        width: 50%;
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 1rem;
        background-color: #fafafa;
    }

    .search-header {
        margin-bottom: 1rem;
    }

    .search-header input {
        width: 100%;
        padding: 6px 10px;
        font-size: 14px;
        border-radius: 4px;
        border: 1px solid #ccc;
    }

    .restaurant-list {
        max-height: 300px;
        overflow-y: auto;
    }

    .restaurant-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 0;
        border-bottom: 1px solid #eee;
    }

    .restaurant-item.selected {
        background-color: #e3f7ff;
    }

    .add-btn,
    .delete-btn {
        background-color: #007bff;
        color: white;
        border: none;
        padding: 4px 10px;
        border-radius: 4px;
        cursor: pointer;
    }

    .delete-btn {
        background-color: #dc3545;
    }

    .add-btn:hover,
    .delete-btn:hover {
        opacity: 0.85;
    }
</style>